<script>
	import Router, { replace }from 'svelte-spa-router';
	import routes from './routes.js';
	import Overlay from './components/Overlay.svelte';
	import Toast from './components/Toast.svelte';
	import { showLoading } from './components/Overlay.svelte';
	import queryString from 'query-string';
	import { onMount } from 'svelte';

	const params = queryString.parse(location.search);

	for(const [key, value] of Object.entries(params)) {
		alert(`${key}: ${value}`)
	}

	
	const routeGuardActivated =(event) => {
		replace('/login');
	}
</script>
<Overlay></Overlay>
<Toast></Toast>
<Router on:conditionsFailed={routeGuardActivated} {routes}/>

<!-- https://fireship.io/lessons/svelte-v3-overview-firebase/ -->